import { Injectable } from '@angular/core';
import { EndSessionWarningModalComponent } from '@app/components/modals/end-session-warning-modal/end-session-warning-modal.component';
import { BehaviorSubject, Observable } from 'rxjs';
import { ModalItem } from '../components/modals/modal-item';
import { IModals, ModalTypes } from '../interfaces';

@Injectable({
	providedIn: 'root',
})
export class ModalService {
	showModal: BehaviorSubject<any> = new BehaviorSubject<any>(null);
	onHideModal: BehaviorSubject<{ type: string; options?: {} }> = new BehaviorSubject<{
		type: string;
		options?: {};
	}>(null);

	private _currentOpenModal: BehaviorSubject<any> = new BehaviorSubject(null);
	private _modals: BehaviorSubject<Array<ModalItem<any>>> = new BehaviorSubject<Array<ModalItem<any>>>([]);
	private _isOpen: BehaviorSubject<boolean> = new BehaviorSubject(false);

	modals$: Observable<Array<ModalItem<any>>> = this._modals.asObservable();
	currentOpenModal$: Observable<any> = this._currentOpenModal.asObservable();
	isOpen$: Observable<boolean> = this._isOpen.asObservable();

	constructor() {
		this.initializeModals();
	}

	private initializeModals() {
		const modals = [
			new ModalItem(EndSessionWarningModalComponent, {
				title: 'Session is expiring',
				type: IModals.endSession,
			}),
		];
		this._modals.next(modals);
	}

	get isOpen(): boolean {
		return this._isOpen.value;
	}

	get modals(): Array<ModalItem<any>> {
		return this._modals.value;
	}

	set modals(newModals: Array<ModalItem<any>>) {
		const currentModals = this._modals.value;
		const modalsAlreadyExists = currentModals.some((c) => newModals.some((modal) => c.data.type === modal.data.type));
		// kinda modals simple cache check
		if (modalsAlreadyExists) {
			return;
		}
		this._modals.next([...currentModals, ...newModals]);
	}

	openModal(type: ModalTypes, options?: {}): void {
		const layout = document.body.querySelector('app-root') as HTMLElement;
		layout.style.height = '100vh';
		this.onHideModal.next(null);
		this.showModal.next({ type, options });
		this._currentOpenModal.next(type);
		this._isOpen.next(true);
	}

	closeModal(options?: {}): void {
		if (this.showModal.value) {
			const layout = document.body.querySelector('app-root') as HTMLElement;
			layout.style.height = 'auto';
			const type = this.showModal.value.type;
			this.showModal.next(null);
			this.onHideModal.next({ type, options });

			this._currentOpenModal.next(null);
			this._isOpen.next(false);
		}
	}
}
